/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import "./style.css";

export const AtomoTime = ({
  className,
  timelineClassName,
  rectangleClassName,
  subtitleCopyClassName,
  subtitleCopyClassNameOverride,
}) => {
  return (
    <div className={`atomo-time ${className}`}>
      <div className={`timeline ${timelineClassName}`}>
        <div className={`rectangle ${rectangleClassName}`} />
      </div>

      <div className="time-text">
        <div className={`subtitle-copy ${subtitleCopyClassName}`}>
          Time remaining:
        </div>

        <div className={`div ${subtitleCopyClassNameOverride}`}>1:50</div>
      </div>
    </div>
  );
};
